import { useSelector } from "react-redux";

export function useIsImpersonation() {
  const authToken = useSelector((state) => state.app.authorization);

  return authToken?.substr(0, 2) === "i_";
}
